import {
  AutocompleteQuery,
  AppSettings,
  TreeTypeEnum,
  AliasSettings,
  Customer,
  ApplicationFilters,
  Criteria,
  CategoryCriteria,
  AppSpecificSettings,
  VariantSettings,
  ClientInfo,
  AppSortSettings,
  MapSettings,
  SortDirectionEnum,
  PagerSettings,
  SearchSettings,
  PartType,
  PartTypeEnum,
  FilterSettings,
  FilterAttributeValue,
  SearchTypeEnum,
  AutocompleteSearchResult,
  AutocompleteCategoryItem,
  BreadcrumbItem,
  Image,
  AutocompleteItem,
  ProductReplacement,
  Link,
  LinkTypeEnum,
  ProductAdditionalInfo,
  ProductAdditionalInfoTypeEnum,
  PrmRelationshipIdentifier,
  Attribute,
  CustomerSpecificData,
  EomObject,
  EomAttribute,
  EomAttributeValue,
  ProductItemClassifications,
  CompareQuery,
  CompareSearchSettings,
  CompareResult,
  CompareClassificationItem,
  ClassificationItem,
  ClassificationAdditionalInfo,
  ClassificationAdditionalInfoTypeEnum,
  CompareProductDetail,
  ProductItem,
  AttributeGroup,
  CountQuery,
  CountSearchResult,
  DetailQuery,
  ProductDetailSettings,
  DetailDataTypeEnum,
  ProductDetail,
  ProductDetailSearchResult,
  AttributeGroupSearchResult,
  ProductClassificationsSearchResult,
  PrmSearchResult,
  PrmRelationship,
  PrmRelationshipTypeEnum,
  PrmRelationshipOrgTypeEnum,
  Table,
  TableColumn,
  TableRow,
  UserField,
  FilterItem,
  InteractiveGuidesSearchResult,
  InteractiveGuide,
  SecurityLevelEnum,
  InteractiveGuideTypeEnum,
  RelatedLinksSearchResult,
  RelatedLink,
  RelatedProductsSearchResult,
  RelatedProduct,
  ProductVariantsSelectorSearchResult,
  ProductVariantAttribute,
  VariantAttributeDisplayModeEnum,
  ProductVariantValue,
  ProductVariantsTableSearchResult,
  ProductVariantGroup,
  ProductVariantGroupAttribute,
  ProductVariantsDropdownSearchResult,
  EomSearchResult,
  FiltersQuery,
  FilterSearchSettings,
  FilterValueSearchResult,
  FilterValueItem,
  FilterValue,
  ListQuery,
  ListSearchSettings,
  ProductListSearchResult,
  ProductListItem,
  PdfQuery,
  ProductSearchSettings,
  PrintResult,
  PreviewQuery,
  ProductPreviewSettings,
  ProductPreview,
  PrmFiltersQuery,
  PrmFilterSettings,
  PrmQuery,
  PrmSearchSettings,
  SearchQuery,
  SearchDataTypeEnum,
  SortSettings,
  SortFieldEnum,
  SearchResult,
  ClassificationsSearchResult,
  ProductSearchResult,
  FilterSearchResult,
  BreadcrumbsSearchResult,
  ConfiguratorItemSearchResult,
  ConfiguratorItem,
  MasterProductSearchResult,
  MasterProduct,
  PartTypesSearchResult,
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class ProductsService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   * Returns autocomplete suggestions based on a partial search term and current app settings.
   */
  static autocomplete(
    params: {
      /** requestBody */
      body?: AutocompleteQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<AutocompleteSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/Autocomplete';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Compares the specified products and returns a unified attribute matrix for side-by-side comparison.
   */
  static compare(
    params: {
      /** requestBody */
      body?: CompareQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CompareResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/Compare';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Counts products matching the provided search criteria and returns the total without product data.
   */
  static count(
    params: {
      /** requestBody */
      body?: CountQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<CountSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/Count';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * Returns the complete product detail for the specified product identifier, including attributes, images, documents,
and relationships.
 */
  static detail(
    params: {
      /** requestBody */
      body?: DetailQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProductDetail> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/Detail';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Retrieves the available filter values (facets) for the products matching the specified search criteria.
   */
  static filters(
    params: {
      /** requestBody */
      body?: FiltersQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FilterValueSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/Filters';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns a paginated product list for the provided product identifiers and app settings.
   */
  static list(
    params: {
      /** requestBody */
      body?: ListQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProductListSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/List';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Downloads a previously generated PDF file by its unique identifier.
   */
  static download(
    params: {
      /** Unique identifier of the generated PDF file returned by the Generate endpoint. */
      guid?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/Pdf/Download';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { guid: params['guid'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Generates a PDF document for the specified products and returns a GUID that can be used to download the file.
   */
  static generate(
    params: {
      /** requestBody */
      body?: PdfQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PrintResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/Pdf/Generate';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns a compact product preview including key attributes, image, and classification for the specified product.
   */
  static preview(
    params: {
      /** requestBody */
      body?: PreviewQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<ProductPreview> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/Preview';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Retrieves the available filter values (facets) for product relationships matching the specified PRM criteria.
   */
  static relationshipFilters(
    params: {
      /** requestBody */
      body?: PrmFiltersQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<FilterValueSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/RelationshipFilters';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Returns related products for the specified source product based on PRM relationship rules.
   */
  static relationships(
    params: {
      /** requestBody */
      body?: PrmQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<PrmSearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/Relationships';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
 * Searches products by keyword, classification, and attribute filters. Returns matching products with pagination and
category navigation.
 */
  static search(
    params: {
      /** requestBody */
      body?: SearchQuery;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<SearchResult> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1/Products/Search';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
